module.exports = __webpack_public_path__ + "static/media/514.b137dc92.svg";